import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { MarketplaceAffiliationPaginated } from '@/queries/marketplace/schema'
import { useQuery } from '@tanstack/react-query'
import {
  GETMarketplacePreviewAffiliations,
  MarketplacePreviewAffiliationsParams,
} from '../requests'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'
import { MarketplaceAccessMode } from '../types'

export const useMarketplacePreviewAffiliations = (
  params: MarketplacePreviewAffiliationsParams,
  mode: MarketplaceAccessMode = 'preview',
  options: CustomQueryOptions<MarketplaceAffiliationPaginated> = {}
) => {
  return useQuery({
    queryKey: MARKETPLACE_PREVIEW_QUERY_KEYS.affiliations(mode, params),
    queryFn: () => GETMarketplacePreviewAffiliations(params, mode),
    ...options,
  })
}
